
import axios from "axios";
import check from "~/store/elementChecker";
export default {
  // beforeRouteEnter (to, from, next) {
  //   if (to.params.q.includes('/')) {
  //       next(to.params.q.replace(/\//g, '%2F'));
  //   }
  //   next();
  // },
  data() {
    return {};
  },
  head() {
    return {
      title: `${(this.$route.params.q || "")
        .replace(/&/g, " και ")
        .split("+")
        .filter(
          (f) =>
            !f.includes("sort") &&
            !f.includes("limit") &&
            !f.includes("orderby") &&
            !f.includes("order") &&
            !f.includes("limit") &&
            !f.includes("page") &&
            !f.includes("tag_key") &&
            f
        )
        .map((m) => m.split("=")[1])
        .join(" - ")} ${this.$store.getters.store.eshop.name}`,
      meta: [
        ...this.$hyperSeo.meta({
          description: `${
            this.$store.getters.sideFilters.business_activity || ""
          } ${this.$store.getters.sideFilters.family || ""} ${
            this.$store.getters.sideFilters.subfamily || ""
          } ${this.$store.getters.sideFilters.category || ""}`,
          "og:description": `${
            this.$store.getters.sideFilters.business_activity || ""
          } ${this.$store.getters.sideFilters.family || ""} ${
            this.$store.getters.sideFilters.subfamily || ""
          } ${this.$store.getters.sideFilters.category || ""}`,
        }),
      ],
    };
  },
  scrollToTop: true,
  async asyncData({ app, req, params, store, route, redirect }) {
    let host = "";
    if (process.server) {
      host = req.headers.host + route.fullPath;
    } else {
      host = location.host + route.fullPath;
    }
    let sorts = store.state.store.eshop.sorting
      ? store.state.store.eshop.sorting
      : [
          { value: "+orderby=display_order+order=asc", label: "Δημοφιλή" },
          { value: "+orderby=created_at+order=asc", label: "Νεότερα" },
          { value: "+orderby=prices.price+order=asc", label: "Τιμή αύξουσα" },
          {
            value: "+orderby=prices.price+order=desc",
            label: "Τιμή φθίνουσα",
          },
        ];
    let page = 1,
      pages = 0,
      limit = 16,
      total = 0,
      pagination = [],
      items = [],
      sideFilters = {
        business_activity: "",
        manufacturer: "",
        family: "",
        subfamily: "",
        category: "",
        subcategory: "",
        q: "",
        limit: 16,
        page: 1,
        pages: 1,
        sorting: {},
      },
      search;
    store.commit("distinct", { clear: true });
    //REFACTOR SE ? anti gia +
    //AUTO EINAI
    // let query = Object.keys(route.query).map(q=>{
    //   return `${q}=${route.query[q]}`;
    // })

    let clearParams = `+${(params.q || "").replace(/___/g, "/")}`;
    clearParams.split("+").forEach((p) => {
      let key = p.split("=")[0];
      let value = p.split("=")[1];
      if (key == "orderby" || key == "order") {
        if (!sideFilters.sorting.value) {
          sideFilters.sorting.value = "";
        }
        sideFilters.sorting.value += `+${key}=${value}`;
        sorts.forEach((s) => {
          if (s.value == sideFilters.sorting.value) {
            sideFilters.sorting.label = s.label;
          }
        });
        return;
      }
      if (key != "") {
        sideFilters[key] = value;
      }
    });
    store.commit("sidePanel", {});
    if (
      (sideFilters["business_activity"] &&
        sideFilters["business_activity"] !=
          store.getters.sideFilters.business_activity) ||
      (sideFilters["q"] && sideFilters["q"] != store.getters.sideFilters.q)
    ) {
      // store.commit("sidePanel", {});
    }
    if (!clearParams.includes("limit")) {
      clearParams += `+limit=${store.getters.store.eshop.limit || 16}`;
    }
    if (!clearParams.includes("orderby")) {
      clearParams += `${(store.state.store.eshop.sorting[0] || {}).value}`;
    }
    let extra = ``;
    search = clearParams
      .split("+")
      .filter((f) => f)
      .map((p) => {
        if (p.split("=")[0] == "q") {
          return `${p.split("=")[0]}=${encodeURIComponent(p.split("=")[1])}`;
        }
        return `${p.split("=")[0]}=${encodeURIComponent(p.split("=")[1])}`;
      })
      .join("+");
    if (store.getters.store.eshop.searchReplicate) {
      extra =
        "&extra=" +
        encodeURIComponent(store.getters.store.eshop.searchReplicate);
    }
    let temp = await axios.get(
      `${process.env.axiosUrl}/items/store/${
        store.state.store.store_id
      }?store_id=${store.state.store.store_id}${extra}&${search.replace(
        /\+/g,
        "&"
      )}`,
      {
        headers: {
          shopster: encodeURIComponent(host),
        },
      }
    );
    temp = temp.data;
    if (temp) {
      items = await app.$hyperItem.prepareItems(
        ((temp || {}).items || []).docs || []
      );
      sideFilters.page = temp.items.page;
      sideFilters.pages = temp.items.pages;
      sideFilters.limit = temp.items.limit;
      sideFilters.total = temp.items.total;
      if (!sideFilters.sorting.value) {
        sideFilters.sorting = (store.state.store.eshop.sorting || [])[0]
          ? store.state.store.eshop.sorting[0]
          : {
              value: "+orderby=display_order+order=asc",
              label: "Δημοφιλή",
            };
      }

      store.commit("sideFilters", sideFilters);
      pagination = [];
      for (let i = 1; i <= temp.items.pages; i++) {
        if (i == 1) {
          pagination.push(i);
        }
        if (
          i > temp.items.page - 5 &&
          i < temp.items.page + 5 &&
          i > 1 &&
          i < temp.items.pages
        ) {
          pagination.push(i);
        }
        if (i == temp.items.pages) {
          pagination.push(i);
        }
      }
      pagination = [...new Set(pagination)];
    }
    store.commit("pagination", pagination);
    store.commit("items", items);
    store.dispatch("getAutoCompletes", {
      properties: "family,subfamily,category",
    });
    store.dispatch("getAutoCompletes", {
      properties: "manufacturer",
    });
    if (
      store.getters.sideFilters.business_activity ||
      store.getters.sideFilters.family ||
      store.getters.sideFilters.subfamily ||
      store.getters.sideFilters.category ||
      store.getters.sideFilters.manufacturer
    ) {
      store.dispatch("getAutoCompletes", {
        properties: "tags",
      });
    }
    if (store.getters.sideFilters.q) {
      store.dispatch("distinctSearch", {
        property: "manufacturer",
        query: store.getters.sideFilters.q,
      });
      store.dispatch("distinctSearch", {
        property: "tags.persons",
        query: store.getters.sideFilters.q,
      });
    }
    let preview = "";
    if ((app || this.$nuxt).$cookies.get("preview")) {
      let pr = ((app || this.$nuxt).$cookies.get("preview") || "").split(":::");
      if (pr[1] == store.getters.store.id) {
        preview = `&preview=${pr[0]}`;
      }
    }
    // check(
    //   store.getters.store.id,
    //   route,
    //   app || $nuxt,
    //   preview,
    //   ((store.getters.store || {}).build_no || {}).timestamp,
    //   (store.getters.store.build || {}).build_no
    // );
    try {
      let res = await axios.get(
        `${process.env.axiosUrl}/stores/${
          store.getters.store.id
        }?elements=${"search"}&build=${
          (store.getters.store.build || {}).build_no
        }&elementsonly=true${preview}`,
        {
          headers: {
            shopster: host,
          },
        }
      );
      if ((res.data || {}).id) {
        store.commit("elements", [
          ...store.getters.store.eshop.elements.filter((e) => e.static),
          ...res.data.eshop.elements,
        ]);
        let es = JSON.parse(JSON.stringify(store.getters.store));
        es.eshop.elements =
          (await app.$hyperElement.populateData({ page: "search", app })) || [];
        store.commit("store", es);
      }
    } catch (e) {
      console.error(e);
    }
    try {
    } catch (error) {}
    store.commit("sub", {
      page,
      pages,
      limit,
      total,
      search,
    });
  },
  methods: {},
  async mounted() {
    if (!Object.keys(this.$store.getters.sidePanel).length) {
      setTimeout(() => {
        this.$nuxt.refresh();
      }, 10);
    }
  },
};
